import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../UI/LanguageSwitcher";

const Footer = () => {
  const { t } = useTranslation();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isImageError, setIsImageError] = useState(false);
  const bgImageUrl = "/assets/icons/top-img-bg.png";

  const quickLinks = [
    { name: t("nav.home"), href: "/" },
    { name: t("nav.about"), href: "/about" },
    { name: t("nav.ourVillas"), href: "/our-villas" },
    { name: t("nav.booking"), href: "/booking" },
    { name: t("nav.services"), href: "/services" },
    { name: t("nav.gastronomy"), href: "/gastronomy" },
    { name: t("nav.reviews"), href: "/reviews" },
    { name: t("nav.gallery"), href: "/gallery" },
    { name: t("nav.contact"), href: "/contact" },
  ];

  return (
    <footer
      // style={{
      //   background:
      //     isImageLoaded && !isImageError
      //       ? `url("${bgImageUrl}") center/cover`
      //       : "#f0f0f0",
      //   color: "#796d66",
      // }}
      className=" text-white bg-[#81736d]"
    >
      <img
        src={bgImageUrl}
        alt=""
        style={{ display: "none" }}
        onLoad={() => setIsImageLoaded(true)}
        onError={() => setIsImageError(true)}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="/assets/icons/logo-negativ-vb.png"
                alt="Village Baidane"
                className="h-16 sm:h-20 lg:h-24 w-auto mr-4"
              />
              {/* <h3 className="text-2xl lg:text-3xl font-sofia font-bold text-white">
                {t("hero.title")}
              </h3> */}
            </div>
            <p className="text-gray-300 mb-6 font-sofia leading-relaxed text-sm lg:text-base max-w-md">
              {t("footer.description")}
            </p>

            {/* Social Links */}
            <div className="flex space-x-4 mb-6">
              <a
                href="https://instagram.com/villagebaidane"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-gray-300 hover:text-accent hover:bg-accent/20 transition-all duration-300 hover:scale-110"
              >
                <span className="sr-only">
                  {t("footer.socialMedia.instagram")}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                >
                  <path d="M7.75 2A5.75 5.75 0 0 0 2 7.75v8.5A5.75 5.75 0 0 0 7.75 22h8.5A5.75 5.75 0 0 0 22 16.25v-8.5A5.75 5.75 0 0 0 16.25 2h-8.5Zm0 1.5h8.5A4.25 4.25 0 0 1 20.5 7.75v8.5a4.25 4.25 0 0 1-4.25 4.25h-8.5a4.25 4.25 0 0 1-4.25-4.25v-8.5A4.25 4.25 0 0 1 7.75 3.5Zm8.75 2a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z" />
                </svg>

                {/* <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.004 5.367 18.637.001 12.017.001zm5.524 7.47c-.418 0-.75-.332-.75-.75s.332-.75.75-.75.75.332.75.75-.332.75-.75.75zm-5.524 8.283c-3.859 0-7.007-3.148-7.007-7.007s3.148-7.007 7.007-7.007 7.007 3.148 7.007 7.007-3.148 7.007-7.007 7.007zm0-11.218c-2.321 0-4.211 1.89-4.211 4.211s1.89 4.211 4.211 4.211 4.211-1.89 4.211-4.211-1.89-4.211-4.211-4.211z"/>
                </svg> */}
              </a>
              <a
                href={`mailto:${t("contact.email")}`}
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-gray-300 hover:text-accent hover:bg-accent/20 transition-all duration-300 hover:scale-110"
              >
                <span className="sr-only">{t("footer.socialMedia.email")}</span>
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </a>
              <a
                href={`tel:${t("contact.phone.morocco").replace(/\s/g, "")}`}
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-gray-300 hover:text-accent hover:bg-accent/20 transition-all duration-300 hover:scale-110"
              >
                <span className="sr-only">{t("footer.socialMedia.phone")}</span>
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h4 className="text-lg font-sofia font-semibold mb-4 text-white">
              {t("footer.quickLinks")}
            </h4>
            <ul className="space-y-3">
              {quickLinks.slice(0, 6).map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-accent font-sofia text-sm transition-all duration-200 hover:translate-x-1 transform inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h4 className="text-lg font-sofia font-semibold mb-4 text-white">
              {t("footer.contactInfo")}
            </h4>
            <div className="space-y-4 text-gray-300 font-sofia">
              <div>
                <h5 className="text-sm font-semibold text-white mb-2">
                  {t("contact.address.title")}
                </h5>
                <div className="text-sm space-y-1">
                  <p>{t("contact.address.line1")}</p>
                  <p>{t("contact.address.line2")}</p>
                  <p>{t("contact.address.line3")}</p>
                </div>
              </div>

              <div>
                <h5 className="text-sm font-semibold text-white mb-2">
                  {t("contact.phone.title")}
                </h5>
                <div className="text-sm space-y-1">
                  <p>
                    <a
                      href={`tel:${t("contact.phone.swiss").replace(
                        /\s/g,
                        ""
                      )}`}
                      className="hover:text-accent transition-colors duration-200"
                    >
                      🇨🇭 {t("contact.phone.swiss")}
                    </a>
                  </p>
                  <p>
                    <a
                      href={`tel:${t("contact.phone.morocco").replace(
                        /\s/g,
                        ""
                      )}`}
                      className="hover:text-accent transition-colors duration-200"
                    >
                      🇲🇦 {t("contact.phone.morocco")}
                    </a>
                  </p>
                </div>
              </div>

              <div>
                <h5 className="text-sm font-semibold text-white mb-2">
                  {t("contact.emailInfo.title")}
                </h5>
                <a
                  href={`mailto:${t("contact.email")}`}
                  className="text-sm hover:text-accent transition-colors duration-200 break-all"
                >
                  {t("contact.email")}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-600 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-gray-300 font-sofia text-sm text-center sm:text-left">
              {t("footer.copyright")}
            </p>

            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <div className="flex space-x-6">
                <Link
                  to="/privacy"
                  className="text-gray-300 hover:text-accent transition-colors duration-200 font-sofia text-sm"
                >
                  {t("footer.privacyPolicy")}
                </Link>
                <Link
                  to="/terms"
                  className="text-gray-300 hover:text-accent transition-colors duration-200 font-sofia text-sm"
                >
                  {t("footer.termsOfService")}
                </Link>
              </div>

             
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
